<template>
  <div>
    <!-- 调用落地页时的loading -->
    <div v-if="loading" class="loading-box">
      <van-loading class="loading-icon" type="spinner" color="#1989fa" />
    </div>
    <!-- 自定义的落地页 -->
    <div
      v-if="marketFormLandPage && !loading"
      class="land-page-box braft-output-content"
      v-html="marketFormLandPage"
    ></div>
    <!-- 默认的落地页 -->
    <div v-if="!marketFormLandPage && !loading" class="msg-box">
      <div class="icon">
        <van-icon color="#4bc818" size="40" name="checked" />
      </div>
      <p class="desc">
        已提交成功，我们将在24小时内联系您，请保持电话畅通！
      </p>
    </div>
  </div>
</template>
<script>
import { get } from '@/utils/request';

export default {
  data: function() {
    return {
      loading: false,
      marketFormLandPage: '',
    };
  },
  methods: {
    getmarketFormLandPage: function(marketFormNo) {
      this.loading = true;
      get('/bp/marketForm/showForm', {
        marketFormNo,
      })
        .then((res) => {
          const { success, rows } = res || {};
          if (success) {
            const { marketFormLandPage } = rows[0] || {};
            this.marketFormLandPage =
              marketFormLandPage && marketFormLandPage !== `<p></p>`
                ? marketFormLandPage
                : '';
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  mounted: function() {
    const { marketFormNo } = this.$route.params;
    if (!marketFormNo) this.$router.push('/notFound');
    this.getmarketFormLandPage(marketFormNo); // 获取落地页信息
  },
};
</script>

<style lang="less" scoped>
@import '../../assets/style/braft-editor.css';
// loading 样式
.loading-box {
  margin: 40vh auto 0;
  text-align: center;
}

// 自定义落地页样式
.land-page-box {
  margin: 16px;
}

// 默认落地页
.msg-box {
  margin-top: 20vh;
  padding: 0 20px;
  .icon {
    text-align: center;
  }
  .desc {
    padding: 20px 0;
    text-align: center;
    line-height: 30px;
  }
}
</style>
